import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminAudienceKey from "@/pages/AdminAudienceKey";
import StaffAdminGate from "@/components/StaffAdminGate";

export const Route = createFileRoute("/admin/audiencekey")({
  head: () => seoHead("/admin/audiencekey"),
  component: () => (
    <StaffAdminGate>
      <AdminAudienceKey />
    </StaffAdminGate>
  ),
});
